import {Injectable} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {BehaviorSubject, filter, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TabSelectionService {
  private currentTab: string;
  private readonly currentTab$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  readonly currentTab$AsObservable: Observable<string> = this.currentTab$.asObservable();

  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
    this.initializeTabSelection();
  }

  private initializeTabSelection() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.currentTab = this.activatedRoute.snapshot.queryParamMap.get('tab');
      this.currentTab$.next(this.currentTab);
    });
  }
}
